<template>
	<section class="main-content contentblocks">
		<div class="row row-header align-center">
			<div v-if="contentBlocksContent.length">
				<h2 class="subtitle">
					{{ contentBlocksSubtitle }}
				</h2>
				<div v-parse-links v-html="contentBlocksContent" />
			</div>
		</div>
		<div v-for="(block, index) in contentblocks" :key="block.ID" class="row contentblock">
			<div class="columns column5 contentblock-content" :class="index % 2 === 0 ? 'right' : 'left'">
				<h2>{{ block.header }}</h2>
				<div v-parse-links v-html="block.content" />
			</div>
			<div class="contentblock-image">
				<picture>
					<source v-if="block.imageWebp" :srcset="block.imageWebp" type="image/webp" />
					<source :srcset="block.image" />
					<img loading="lazy" :src="block.image" :alt="block.imageAlt" />
				</picture>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	contentblocks: { type: Array, default: () => [] },
	contentBlocksContent: { type: String, default: '' },
	contentBlocksSubtitle: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--primary-background-color);
	position: relative;
	overflow: hidden;

	.row {
		position: relative;
		z-index: 2;
		overflow: auto;
	}
}

.background-light {
	background: var(--primary-background-color);
}

.contentblock {
	margin: 40px auto 75px;
	position: relative;
	min-height: 650px;
	overflow: visible;
}

.row-header {
	max-width: 1000px;
}

.contentblock-image {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	width: 75%;
	z-index: 1;
}

.contentblock-content {
	background: var(--alternating-background-color);
	padding: 60px 90px;
	position: relative;
	margin: 75px 0;
	z-index: 2;
	min-height: 500px;

	:deep(a:not(.button)) {
		color: #000;

		&:hover {
			color: #333;
		}
	}

	:deep(p) {
		color: #fff;
	}
}

.row:nth-child(even) .contentblock-image {
	left: 0;
	right: auto;
}

.contentblock-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

@media (max-width: 920px) {
	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto;
	}

	.contentblock {
		display: flex;
		flex-flow: wrap column-reverse;
		max-width: 720px;
		margin: 25px auto;
	}

	.contentblock-content {
		position: relative;
		top: 0;
		transform: none;
		margin: 0 auto;
		padding: 50px 30px;
		width: 100%;
	}
}
</style>
